export const FormatDataToCreateVendor = (initials, description, management) => {
  return {
    initials,
    description,
    managementId: management.id
  };
};
